import { render } from "./EntitlementUsageCharts.vue?vue&type=template&id=1cba10e0&scoped=true"
import script from "./EntitlementUsageCharts.vue?vue&type=script&lang=js"
export * from "./EntitlementUsageCharts.vue?vue&type=script&lang=js"

import "./EntitlementUsageCharts.vue?vue&type=style&index=0&id=1cba10e0&scoped=true&lang=css"

import exportComponent from "/Users/sandhiyabaskar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cba10e0"]])

export default __exports__